import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Select } from 'antd';
import { CarOutlined, CloseOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { ApplicationState } from '../../../../../../../../../store';
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import {
  getTipoVeiculos,
  ListarVeiculosOrdemDeColetaServices,
} from '../../services/editarOrdemDeColetaServices';
import mask from 'utils/mask';
import TitlePage from 'components/TitlePage';
import { TextLabel } from 'components/TextLabel';

interface Props {
  setSelectedVeiculo: React.Dispatch<React.SetStateAction<number>>;
  codVeiculo: number;
  setCodTipValue: React.Dispatch<React.SetStateAction<number>>;
  codTipoCarroceria: number;
  setDisabledButton: React.Dispatch<React.SetStateAction<boolean>>;
  setShowhorarios: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAlert: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalVeiculo: React.FC<Props> = ({
  setSelectedVeiculo,
  setCodTipValue,
  setDisabledButton,
  setShowhorarios,
  setShowAlert,
  codTipoCarroceria,
  codVeiculo,
}) => {
  const { Option } = Select;
  const [formSelect] = Form.useForm();
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const loading = useSelector((state: ApplicationState) => state.DetalheVeiculo.loading);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [veiculos, setVeiculos] = useState<any>([]);
  const [tiposVeiculo, setTiposVeiculo] = useState<any>();

  useEffect(() => {
    ListarVeiculosOrdemDeColetaServices.getVeiculosPortal(inscricaoAtiva).then((res) => {
      setVeiculos(res.data?.veiculos);
    });
  }, [inscricaoAtiva]);

  useEffect(() => {
    try {
      getTipoVeiculos.getTipoVeiculos().then((res) => {
        setTiposVeiculo(res.data.tiposVeiculos);
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar a lista de veículos, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }, []);

  const handleSetSelectCodTip = (_value: string, e: any) => {
    setDisabledButton(true);
    setShowhorarios(false);
    setShowAlert(false);
  };

  const onFinish = (values: any) => {
    if (values.codVeiculo) {
      setSelectedVeiculo(values.codVeiculo);
    }

    if (values.codTip) {
      setCodTipValue(values.codTip);
      setShowhorarios(true);
      setShowAlert(true);
    }
    setIsModalVisible(false);
    formSelect.resetFields();
  };
  return (
    <>
      <Modal
        centered
        title={<TitlePage>Veículos</TitlePage>}
        visible={isModalVisible}
        onCancel={() => {
          formSelect.resetFields();
          setIsModalVisible(false);
        }}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={850}
        footer={[]}
      >
        <Form form={formSelect} onFinish={onFinish}>
          {!loading ? (
            <Row gutter={24}>
              <Col md={12} sm={24} xs={24}>
                <Form.Item
                  style={{ display: 'table', width: '100%' }}
                  name="codTip"
                  label={
                    <TextLabel>
                      <CarOutlined /> Tipo do veículo
                    </TextLabel>
                  }
                >
                  <Select
                    placeholder="Selecione um tipo de veículo"
                    filterOption={(inputValue, element) =>
                      element?.children.toString().toLowerCase().includes(inputValue.toLowerCase())
                    }
                    showSearch
                    onChange={handleSetSelectCodTip}
                  >
                    {tiposVeiculo?.map((item: any, index: number) => {
                      return (
                        <Option key={item.codTip} value={item.codTip}>
                          <p>{mask('camelCase', item.nome)}</p>
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col md={12} sm={24} xs={24}>
                <Form.Item
                  style={{ display: 'table', width: '100%' }}
                  name="codVeiculo"
                  label={
                    <TextLabel>
                      {' '}
                      <CarOutlined /> Placa do veículo
                    </TextLabel>
                  }
                >
                  <Select
                    showSearch
                    filterOption={(inputValue, element) =>
                      element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
                    }
                    disabled={false}
                    placeholder="Selecione a placa do seu veículo"
                  >
                    {veiculos.map((item: any) => (
                      <>
                        <Option key={item.codVeiculo} value={item.codVeiculo} style={{ marginBottom: "5px" }}>
                          {item.placa?.toUpperCase()}
                        </Option>
                      </>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          ) : (
            <LoadingOutlined />
          )}

          <Col style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <Button type="primary" htmlType="submit">
              OK
            </Button>
          </Col>
        </Form>
      </Modal>

      <Button
        style={{
          width: '100%',
        }}
        type="default"
        onClick={() => setIsModalVisible(true)}
      >
        <span
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            color: '#9f9f9f',
          }}
        >
          {veiculos.find((item: any) => item.codVeiculo === codVeiculo)?.placa?.toUpperCase()
            ? veiculos.find((item: any) => item.codVeiculo === codVeiculo)?.placa?.toUpperCase() +
            ' - ' +
            mask(
              'camelCase',
              tiposVeiculo?.find((item: any) => item.codTip === codTipoCarroceria)?.nome
            )
            : 'Carregando...'}
        </span>
      </Button>
    </>
  );
};

export default ModalVeiculo;
